/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanySaveDocumentsRequest = {
  properties: {
    citySubscriptionNumber: {
      type: 'string',
    },
    stateSubscriptionNumber: {
      type: 'string',
    },
    documents: {
      type: 'array',
      contains: {
        type: 'CompanyDocument',
      },
      isRequired: true,
    },
  },
} as const;
